import { render } from "./ChangePWD.vue?vue&type=template&id=f756c264&scoped=true&ts=true"
import script from "./ChangePWD.vue?vue&type=script&lang=ts"
export * from "./ChangePWD.vue?vue&type=script&lang=ts"

import "./ChangePWD.vue?vue&type=style&index=0&id=f756c264&scoped=true&lang=scss"

import exportComponent from "D:\\project\\unnati\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f756c264"]])

export default __exports__